<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-100" [formGroup]="form">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-content" class="modal-title">Edit Position</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-6 form-group">
            <label>Payment Mode</label>
            <input type="text" formControlName="payment_mode_name" class="form-control">
          </div>
        </div>

        <section formGroupName="payment_options">
          <div class="row border-top border-bottom mx-0">
            <div class="col-lg-8 col-md-8 card-header card-header-color2 p-3 border-right border-left">
              <span class="kt-font-bold">Payment Option</span>
            </div>
            <div class="col-lg-4 col-md-4 card-header card-header-color2 p-3 text-center border-right">
              <span class="kt-font-bold">Position</span>
            </div>
          </div>

          <div class="row border-bottom mx-0" *ngFor="let paymentOption of data.paymentMode.payment_options; let i = index" [formGroupName]="i">
            <div class="col-lg-8 col-md-8 p-3 border-right border-left">
              <label>{{ paymentOption.payment_option_name }}</label>
            </div>
            <div class="col-lg-4 col-md-4 p-3 border-right">
              <input type="number" class="form-control" formControlName="position" min="1" max="99"
                [ngClass]="{'is-invalid': form.get('payment_options.'+i+'.position')?.errors}">
              <div class="invalid-feedback" *ngIf="form.get('payment_options.'+i+'.position')?.errors?.min || form.get('payment_options.'+i+'.position')?.errors?.max">
                Position must be between 1 and 99.
              </div>
              <div class="invalid-feedback" *ngIf="form.get('payment_options.'+i+'.position')?.errors?.required">
                Position is required.
              </div>
            </div>
          </div>

          <div class="row mx-0" *ngIf="data.paymentMode.payment_options.length === 0">
            <div class="col-12 p-3 text-center text-muted">
              No data available.
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <kt-submit-button [isDisabled]="!form.valid || data.paymentMode.payment_options.length === 0" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
      </div>

    </div>
  </form>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event)"></kt-swal-alert>
